import { controls, grouped } from "../../controls";

const rp301 = {
  label: "Trial Balance",
  starting: true,
  url: "rp301",
  pageLabel: "Trial Balance",
  pageType: "history",
  // filteraction: true,
  filter: [

    ...controls.displayText({ tab: "general", label: "Branch", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", isRequired: true, fastpath: "ho100" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),

    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As on Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.checkBox({
      tab: "filter", label: "Show Zero Value GL", name: "isZeroBalGL", width: "col-sm-12", tag: "basic"
    }),

    ...controls.checkBox({
      tab: "filter", label: "Show Floating Balance", name: "isFloatingSeparate", width: "col-sm-12", tag: "basic"
    }),


    ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag: "basic" }),


    ...grouped.grouping('basic'),


    // ...controls.displayText({ label: "Region", width: "col-sm-3", tag: "basic" }),
    // ...controls.Region({ tag: "basic", width: "col-sm-3" }),

    // {
    //   inputType: "showdata",
    //   tab: "Modal",
    //   data: "region",
    //   textcolor: "black",
    //   name: "region_display",
    //   widths: {
    //     parent: "col-sm-5",
    //     children: "col-sm-12"
    //   }, tag: "basic"
    // },
    // ...controls.displayText({ tab: "filter", label: "Receipt/Payment", width: "col-sm-3", tag: "basic" }),
    // ...controls.RecPayType({tab:'filter', tag: "basic"}),
    // ...controls.displayText({ tab: "filter", width: "col-sm-2", tag: "basic" }),
    ...grouped.separation('advance'),
    ...grouped.comparative('advance'),
    ...grouped.bulk('advance'),
    ...grouped.grouping('advance'),
    ...controls.checkBox({ tab: "filter", label: "Summary", name: "isSummary", width: "col-sm-12", tag: "advance" }),

    // ...grouped.getFromDB('action'),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Trial Balance",
    clickable: false,
    defaultsTo: 0,
    textReportProps: {
      '132': {
        filename: `Trial_Balance_$pageData.branch_code$.txt`,
        header: "default",
        footer: "default",
      }
    },
    extraRows: {
      fields: ["credit_cash", "debit_cash"],
      location: "top",
      grandtotal: {
        type: "fixed", displayIn: "description", val: "Grand Total", count: true
      },
    },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        align: 'center',
        width132: { size: 3 },
      },
      {
        Header: "GL",
        accessor: "gl",
        align: 'center',
        width132: { size: 30 },
      },
      {
        Header: "Description",
        accessor: "description",
        rwidth: "*",
        type: "uppercase",
        width132: { size: 30 },
      },
      {
        Header: "Credit",
        accessor: "credit_cash",
        type: "currency",
        width132: { size: 16 },
      },
      {
        Header: "Debit",
        accessor: "debit_cash",
        type: "currency",
        width132: { size: 16 },
      },
    ]
  }
};

export default rp301;